(function () {

  'use strict';

  eclipseApp.controller('NotifierModalCtrl', ['$scope', '$modalInstance', 'notifier', '$timeout', 'data', 'errorCodeMap', '$log', function ($scope, $modalInstance, notifier, $timeout, data, errorCodeMap, $log) {

    //console.log('@NotifierModalCtrl LOADED!');
    $scope.phase = notifier.phase || data;

    $scope.getErrorCodeDescription = function(code){
      if (code){
        if (code in errorCodeMap) {
          return errorCodeMap[code];
        } else {
          $scope.phase = {
            last: true,
            data: {
              errorCode: code
            }
          };
          
          $log.info('@NotifierModalCtrl: Unable to find ' + code + ' in errorCodeMap');
        }
      }
    };

    //console.log('@NotifierModalCtrl:$scope.phase: ', $scope.phase);

    $scope.ok = function () {
      $modalInstance.close();
    };

    $scope.cancel = function () {
      $modalInstance.close();
    };


  }]);

})();
